import mutationsTypes from '@/vuex/busca-documentos/mutations-types.js'
const types = {
  ...mutationsTypes,
  INICIALIZAR_DADOS_BUSCA_DOCUMENTOS: 'INICIALIZAR_DADOS_BUSCA_DOCUMENTOS',
  GET_LISTA_INTERESSADOS: 'GET_LISTA_INTERESSADOS',
  GET_LISTA_RESPONSAVEL_TRAMITACAO: 'GET_LISTA_RESPONSAVEL_TRAMITACAO',
  GET_INTERESSADO_POR_CODIGO: 'GET_INTERESSADO_POR_CODIGO',
  GET_RESPONSAVEL_TRAMITACAO_POR_CODIGO: 'GET_RESPONSAVEL_TRAMITACAO_POR_CODIGO',
  GET_LISTA_TODOS_TIPOS_DOCUMENTO: 'GET_LISTA_TODOS_TIPOS_DOCUMENTO',
  GET_LISTA_TIPOS_INTERESSADO: 'GET_LISTA_TIPOS_INTERESSADO',
  GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO: 'GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO',
  GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA: 'GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA',
  GET_LISTA_SERVIDORES_PROCEDENCIA: 'GET_LISTA_SERVIDORES_PROCEDENCIA',
  GET_LISTA_TIPOS_DOCUMENTO_AUTORIZADOS: 'GET_LISTA_TIPOS_DOCUMENTO_AUTORIZADOS',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/busca-documentos/actions-types.js